import styled from 'styled-components';

import { BlankSpace, BlockHeader, InnerGrid } from '../../style';
import { Date } from 'components/primitives/content';

export const Space4 = styled(BlankSpace)`
  grid-area: space4;
`;

export const GridStyled = styled(InnerGrid)`
  grid-template-areas:
    'title title title title title title'
    'issue-date-input issue-date-input . . . .';
  grid-area: issue-date;
  margin-bottom: 20px;
`;

export const BlockCarIssueDateHeader = styled(BlockHeader)`
  grid-area: title;
`;

export const CarIssueDate = styled(Date)`
  grid-area: issue-date-input;
`;
